<div class="grid ">
	<div class="col-12">
		<div class="card">
			<h5>Editar Plano Conta Matriz</h5>
			<form #f="ngForm" name="form" novalidate>
				<div class="p-fluid p-formgrid grid" *ngIf="loadingPlanoConta">
					<div class="field col-12 md:col-12">
						<p-divider></p-divider>
					</div>
				</div>
				<div class="flex justify-content-center" *ngIf="loadingPlanoConta">
					<p-progressSpinner></p-progressSpinner>
				</div>
				<div class="formgroup" *ngIf="planoContaMatriz">
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-12">
							<p-divider></p-divider>
						</div>
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>
						<div class="field col-12 md:col-1">
							<label htmlFor="id">Código</label>
							<input pInputText type="text" name="id" ngModel readonly="true"
							#id="ngModel" [(ngModel)]="planoContaMatriz.id"/>
						</div>
						<div class="field col-12 md:col-4">
							<label htmlFor="descricao">Descrição</label>
							<input oninput="this.value = this.value.toUpperCase();" name="descricao" type="text"
								pInputText placeholder="Digite a descrição" ngModel
								[(ngModel)]="planoContaMatriz.descricao" #descricao="ngModel" required />
							<div *ngIf="descricao.hasError('required') && descricao.touched">
								<small>Campo obrigatório</small>
							</div>

						</div>
						<div class="field col-12 md:col-7">
							<label htmlFor="especificacao">Especificação</label>
							<input name="especificacao" type="text" (blur)="planoContaMatriz.especificacao = especificacao.value.toUpperCase()"
								pInputText placeholder="Digite a especificação" ngModel
								[(ngModel)]="planoContaMatriz.especificacao" #especificacao="ngModel" required />
							<div *ngIf="especificacao.hasError('required') && especificacao.touched">
								<small>Campo obrigatório</small>
							</div>

						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="dre">DRE</label>
							<p-dropdown [options]="categoriasDre" [filter]="true"
								placeholder="Selecione" name="dre" ngModel #dre="ngModel"
								[(ngModel)]="planoContaMatriz.dre" [required]="true">
							</p-dropdown>
							<div *ngIf="dre.hasError('required') && dre.touched">
								<small>Campo obrigatório</small>
							</div>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="planoContaGrupo">Plano Conta Grupo</label>
							<p-dropdown [options]="planosContaGrupos" optionLabel="descricao" [filter]="true"
								placeholder="Selecione" name="planoContaGrupo" ngModel #planoContaGrupo="ngModel"
								[(ngModel)]="planoContaMatriz.planoContaGrupo" [required]="true">
							</p-dropdown>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="utilizacao">Utilização</label>
							<p-dropdown [options]="utilizacoes"
								placeholder="Selecione" name="utilizacao" ngModel #utilizacao="ngModel"
								[(ngModel)]="planoContaMatriz.utilizacao" [required]="true">
							</p-dropdown>
						</div>
						<div class="field col-12 md:col-2" *ngIf="planoContaMatriz.planoContaGrupo?.id === 3">
							<label htmlFor="referenciaFolha">Referência Folha</label>
							<p-dropdown [options]="referenciasFolha" placeholder="Selecione" name="referenciaFolha" ngModel
								#referenciaFolha="ngModel" [(ngModel)]="planoContaMatriz.referenciaFolha" [required]="true">
							</p-dropdown>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="patrimonial">Patrimonial</label>
							<p-dropdown [options]="categoriasPatrimonial" [filter]="true"
								placeholder="Selecione" name="patrimonial" ngModel #patrimonial="ngModel"
								[(ngModel)]="planoContaMatriz.patrimonial" [required]="true">
							</p-dropdown>
							<div *ngIf="patrimonial.hasError('required') && patrimonial.touched">
								<small>Campo obrigatório</small>
							</div>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="prioridade">Prioridade</label>
							<p-dropdown [options]="prioridades" optionLabel="label" optionValue="value" [filter]="true"
								placeholder="Selecione" name="prioridade" ngModel #planoContaGrupo="ngModel"
								[(ngModel)]="planoContaMatriz.prioridade" [required]="true">
							</p-dropdown>
						</div>

						<div class="field col-12 md:col-2">
							<label htmlFor="configuravel">Configuravel</label>
							<br>
							<p-inputSwitch name="configuravel"
								[(ngModel)]="planoContaMatriz.configuravel"></p-inputSwitch>
						</div>

					</div>
					<div class="p-fluid p-formgrid grid justify-content-between">
							<div class="field col-12 md:col-2">
								<button type="button" pButton [icon]="progressoRequisicaoAtualizar ? 'pi pi-spin pi-spinner' : 'pi pi-check'" label="Atualizar" (click)="atualizar()"
									class="p-button-success mt-5" [disabled]="!f.valid || progressoRequisicaoAtualizar || loadingContaEmpresa"></button>
							</div>
							<div class="field col-12 md:col-3">
								<button type="button" pButton *ngIf="contaEditada"
								[icon]="loadingContaEmpresa ? 'pi pi-spin pi-spinner' : 'pi pi-check'" [disabled]="loadingContaEmpresa || progressoRequisicaoAtualizar"
								 label="Atualizar Empresas" (click)="atualizarEmpresas()" class="p-button-success mt-5"></button>
							</div>
						<div class="field col-12 md:col-2">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-primary mt-5" routerLink="/rfarias/plano-contas-matriz"></button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>